import {FC} from 'react';
import clsx from 'clsx';

import s from './styles.module.scss';

interface HeaderBalanceProps {
  balance: string;
}

const HeaderBalance: FC<HeaderBalanceProps> = ({balance}) => (
  <a href="/profile/credit" className={s.balance}>
    <span className={clsx(s.balance__current, s.balance__item)}>
      <span className={s['balance__current-label']}>Balance:</span>
      <span>${balance}</span>
    </span>
    <span className={clsx(s.balance__item, s.balance__fund)}>+</span>
  </a>
);

export default HeaderBalance;
